<template>
  <div class="project-cards-container" style="height: 100%;">
    <!-- 卡片内容区域 -->
    <!-- <div class="cards-content" v-if="paginatedCards.length > 0"> -->
      <div class="cards-grid">
        <div 
          v-for="(card, index) in paginatedCards" 
          :key="index"
          class="card-wrapper"
          @click="handleCardClick(card)"
        >
          <div class="project-card">
            <!-- 项目标题区域 -->
            <div class="card-header">
              <div 
                class="project-title" 
                :title="card.项目名称 || card.projectName || defaultData.项目名称"
              >
                {{ card.项目名称 || card.projectName || defaultData.项目名称 }}
              </div>
              <div 
                class="project-status" 
                :class="getStatusClass(card.项目阶段 || card.projectStatus)"
                :title="card.项目状态 || card.projectStatus || defaultData.项目阶段"
              >
                {{ card.项目阶段 || card.projectStatus || defaultData.项目阶段 }}
              </div>
            </div>

            <!-- 项目基本信息 -->
            <div class="card-body">
              <!-- 第一行：业务部门、业务员 -->
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">业务部门：</span>
                  <span 
                    class="info-value" 
                    :title="card.业务部门 || card.department || defaultData.业务部门"
                  >
                    {{ card.业务部门 || card.department || defaultData.业务部门 }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">业务员：</span>
                  <span 
                    class="info-value" 
                    :title="card.业务员 || card.salesperson || defaultData.业务员"
                  >
                    {{ card.业务员 || card.salesperson || defaultData.业务员 }}
                  </span>
                </div>
              </div>

              <!-- 第二行：更新时间、录入时间 -->
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">更新时间：</span>
                  <span 
                    class="info-value" 
                    :title="formatDate(card.更新时间 || card.updateTime) || defaultData.更新时间"
                  >
                    {{ formatDate(card.更新时间 || card.updateTime) || defaultData.更新时间 }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">录入时间：</span>
                  <span 
                    class="info-value" 
                    :title="formatDate(card.录入时间 || card.createTime) || defaultData.录入时间"
                  >
                    {{ formatDate(card.录入时间 || card.createTime) || defaultData.录入时间 }}
                  </span>
                </div>
              </div>

              <!-- 第四行：投标日期、合同数量 -->
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">预计投标日期：</span>
                  <span 
                    class="info-value" 
                    :title="formatDate(card.预计投标日期) || defaultData.投标日期"
                  >
                    {{ formatDate(card.预计投标日期) || defaultData.投标日期 }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">合同数量：</span>
                  <span 
                    class="info-value" 
                    :title="card.合同数量 || card.contractCount || defaultData.合同数量"
                  >
                    {{ card.合同数量 || card.contractCount || defaultData.合同数量 }}
                  </span>
                </div>
              </div>
              <!-- 第四行：业主单位、预计金额 -->
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">项目预计金额：</span>
                  <span 
                    class="info-value" 
                    :title="formatCurrency(card.项目预计金额 || card.estimatedAmount) || defaultData.项目预计金额"
                  >
                    {{ formatCurrency(card.预计金额 || card.estimatedAmount) || defaultData.项目预计金额 }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">合同总金额：</span>
                  <span 
                    class="info-value" 
                    :title="formatCurrency(card.合同总金额) || defaultData.合同总金额"
                  >
                    {{ formatCurrency(card.合同总金额) || defaultData.合同总金额 }}
                  </span>
                </div>
              </div>
              <!-- 第三行：业主单位、预计金额 -->
              <div class="info-row">
                <div class="info-item full-width">
                  <span class="info-label">业主单位：</span>
                  <span 
                    class="info-value" 
                    :title="card.业主单位 || card.owner || defaultData.业主单位"
                  >
                    {{ card.业主单位 || card.owner || defaultData.业主单位 }}
                  </span>
                </div>
              </div>

              

            </div>

            <!-- 底部统计区域 -->
            <div class="card-footer">
              <!-- 合同进度卡片 -->
              <div class="stat-card contract-card" :title="`已审核/总合同数: ${card.已审核合同数量 || defaultData.已审核合同数量}/${card.合同数量 || defaultData.合同总数}`">
                <div class="stat-content">
                  <div class="stat-label">合同</div>
                  <div class="stat-value">
                    {{ card.已审核合同数量 || defaultData.已审核合同数量 }}/
                    {{ card.合同数量 || defaultData.合同总数 }}
                  </div>
                </div>
              </div>

              <!-- 任务进度卡片 -->
              <div class="stat-card task-card" :title="`已开工/任务总数: ${card.已开工任务单数量 != null ? card.已开工任务单数量 : defaultData.已开工任务单数量}/${card.总任务单数量 != null ? card.总任务单数量 : defaultData.总任务单数量}`">
                <div class="stat-content">
                  <div class="stat-label">任务</div>
                  <div class="stat-value">
                    {{ card.已开工任务单数量 != null ? card.已开工任务单数量 : defaultData.已开工任务单数量 }}/
                    {{ card.总任务单数量 != null ? card.总任务单数量 : defaultData.总任务单数量 }}
                  </div>
                </div>
              </div>

              <!-- 售后数量卡片 -->
              <div class="stat-card after-sales-card" :title="`售后数量: ${card.售后数量 != null ? card.售后数量 : defaultData.售后数量}`">
                <div class="stat-content">
                  <div class="stat-label">售后</div>
                  <div class="stat-value">{{ card.售后数量 != null ? card.售后数量 : defaultData.售后数量 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->



    <!-- 分页组件，参考 card-table 的设计 -->
    <paging
      v-if="showPaging && totalCards > 0"
      @sizeChange="handleSizeChanges"
      @currentChange="handleCurrentChanges"
      :total="total"
      :pageSizes="pageSizes"
      :size="pageSize"
      :showPaging="showPaging"
      style="margin-bottom: 30px;"
    ></paging>
  </div>
    <!-- </div> -->
</template>

<script>
export default {
  name: 'ProjectCards',
  props: {
    cardData: {
      type: Array,
      default: () => []
    },
    // 新增：分页相关属性
    total: {  // 总数据量，从父组件传入
      type: Number,
      default: 0
    },
    currentPage: {  // 当前页码，从父组件传入
      type: Number,
      default: 1
    },
    pageSize: {  // 每页显示数量
      type: Number,
      default: 6
    },
    pageSizes: {
      type: Array,
      default: () => [6, 12, 18, 24]
      // default: () => [6]
    },
    showPaging: {  // 是否显示分页
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultData: {
        项目名称: '未命名项目',
        项目阶段: '跟进',
        业务部门: '未分配部门',
        业务员: '未指定',
        更新时间: '--',
        录入时间: '--',
        业主单位: '未指定业主',
        项目预计金额: '0.00元',
        投标日期: '--',
        合同总金额: '0.00元',
        合同数量: '0个',
        已审核合同数量: 0,
        合同总数: 0,
        已开工任务单数量: 0,
        总任务单数量: 0,
        售后数量: 0
      }
    }
  },
  computed: {
    totalCards() {
      return this.cardData.length
    },
    // 当前页的卡片数据（从父组件传入，无需本地计算）
    paginatedCards() {
      return this.cardData;
    }
  },
  methods: {
    // 分页大小变化处理
    handleSizeChanges(val) {
      this.$emit('sizeChange', val);
    },
    
    // 当前页码变化处理
    handleCurrentChanges(val) {
      this.$emit('currentChange', val);
    },
    
    // 卡片点击事件
    handleCardClick(card) {
      console.log('卡片被点击:', card);
      this.$emit('cardClick', card);
      
      // 如果需要触发和表格标题一样的跳转
      this.$emit('projectLinkClick', { row: card });
      
      // 或者直接调用 goToInfo
      // this.goToInfo(card);
    },
    
    // 跳转到详情页（可选的内部实现）
    goToInfo(card) {
      if (card && card.项目名称) {
        const encodedName = encodeURIComponent(card.项目名称);
        this.$router.push(`/homepage/project/${encodedName}`);
        this.$EventBus.$emit('currentPath', '/homepage/project');
      } else {
        console.warn('无法跳转：缺少项目名称');
      }
    },
    
    formatDate(date) {
      if (!date) return ''
      if (typeof date === 'number' || /^\d+$/.test(date)) {
        const d = new Date(parseInt(date))
        return d.toISOString().split('T')[0]
      }
      return date
    },
    
    formatCurrency(amount) {
      if (!amount && amount !== 0) return '0.00元'
      const num = typeof amount === 'string' ? 
        parseFloat(amount.replace(/[^0-9.-]+/g, '')) : 
        Number(amount)
      
      if (isNaN(num)) return '0.00元'
      
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '元'
    },
    
    getStatusClass(status) {
      const statusMap = {
        '中标': 'status-success',
        '中止': 'status-paused',
        '未中标': 'status-failed',
        '投标': 'status-bidding',
        '跟进': 'status-following',
        '收集': 'status-collecting',
        '其他': 'status-other'
      }
      return statusMap[status] || 'status-default'
    }
  },
  watch: {
    cardData() {
      this.currentPage = 1
    }
  }
}
</script>

<style scoped lang="scss">
.project-cards-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
//   background-color: #f5f7fa;
  min-height: 0;
  // overflow: hidden;
  // overflow: auto;

}

// .cards-content {
//   flex: 1;
//   min-height: 0;
//   overflow: auto;
//   padding: 16px 16px 0 16px;
//   display: flex;
//   flex-direction: column;
// }

.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: repeat(2, 1fr);;
  gap: 16px;
  width: 100%;
  min-height: 0;
  max-height:100%;
  overflow: auto;
  align-items: stretch;
  flex: 1;
      
}

.cards-grid:has(> .card-wrapper:nth-child(4)) {
  /* 有4个或更多卡片时显示完整2行 */
  grid-template-rows: repeat(2, 1fr);
  .project-card {
  width: 100%;
  height: 99%;
  }
}

.cards-grid:has(> .card-wrapper:first-child:nth-last-child(-n+3)) {
  /* 只有1-3个卡片时只显示1行 */
  grid-template-rows: 1fr;
  height: 100%; /* 高度减半 */
  .project-card {
  width: 100%;
  height: 51%; /* 高度减半 */
  }
}

.card-wrapper {
  display: flex;
  min-height: 210px;
  //max-height: 310px;
  min-width: 50px;

}

.project-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);  //卡片阴影
  border: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;

  /* ✅ 关键：垂直居中 */
  justify-content: center;   // 核心
  align-items: stretch;

  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);//这个仅仅是悬浮卡片阴影加深
    transform: translateY(-2px);
  }
}

/* 卡片内部样式保持不变 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
//   border-bottom: 1px solid #f0f0f0;
//   background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
  flex-shrink: 0;
  min-height: 35px;
}

.project-title {
  font-size: 16px;
  font-weight: 600;
  color: #2564CFCC;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 12px;
  cursor: default;
  position: relative;
  min-width: 0;
  text-align: left; 
}

.project-title:hover::after {
  content: attr(data-full-title);
  position: absolute;
  top: 100%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  white-space: normal;
  max-width: 300px;
  z-index: 9999;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.2s;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.project-title::after {
  content: attr(data-full-title);
  position: absolute;
  top: 100%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  white-space: normal;
  max-width: 300px;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.project-status {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  
  &.status-success {
    background-color: rgba(82, 196, 26, 0.1);
    color: #52c41a;
  }
  
  &.status-paused {
    background-color: rgba(250, 173, 20, 0.1);
    color: #faad14;
  }
  
  &.status-failed {
    background-color: rgba(255, 77, 79, 0.1);
    color: #ff4d4f;
  }
  
  &.status-bidding {
    background-color: rgba(24, 144, 255, 0.1);
    color: #1890ff;
  }
  
  &.status-following {
    background-color: rgba(114, 46, 209, 0.1);
    color: #722ed1;
  }
  
  &.status-collecting {
    background-color: rgba(19, 194, 194, 0.1);
    color: #13c2c2;
  }
  
  &.status-other {
    background-color: rgba(0, 0, 0, 0.06);
    color: #666;
  }
  
  &.status-default {
    background-color: rgba(0, 0, 0, 0.06);
    color: #666;
  }
}

.card-body {
  flex: 1;
  padding: 0px 12px;
  overflow-y: auto;
  height: 60%;
  min-height: 0;
  max-height: 120px;
  text-align: left;
    // background-color: rgba(0, 0, 0, 0.02);

}

.info-row {
  display: flex;
  margin-bottom: clamp(1px, 1%, 15px); 
//   margin-bottom: 5px; 
  align-items: center;
  gap: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.info-item {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  
  &.full-width {
    flex: 0 0 100%;
  }
}

.info-label {
  font-size: 12px;
  color: #4D4F53;
  // color: #8c8c8c;
  margin-right: 4px;
  flex-shrink: 0;
  white-space: nowrap;
}

.info-value {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
  position: relative;
  display: block;
  width: 100%;
  flex: 1;
  min-width: 0;
}

.info-value:hover::after {
  content: attr(data-full-value);
  position: absolute;
  top: 100%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  white-space: normal;
  max-width: 300px;
  z-index: 9999;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.2s;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.info-value::after {
  content: attr(data-full-value);
  position: absolute;
  top: 100%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  white-space: normal;
  max-width: 300px;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.card-footer {
  display: flex;
  padding: 5px 10px;
  height: 25%;
  max-height: 80px;
  min-height: 0;
//   border-top: 1px solid #f0f0f0;
//   background-color: #fafafa;
  gap: 8px;
  flex-shrink: 0;
  text-align: center;
  justify-content: center;
}

.stat-card {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 6px;
  min-height: 30px;
//   height: 30px;
  text-align: center;
  justify-content: center;
  
  &.contract-card {
    background-color: rgba(37, 100, 207, 0.08);
  }
  
  &.task-card {
    background-color: rgba(255, 77, 79, 0.08);
  }
  
  &.after-sales-card {
    background-color: rgba(82, 196, 26, 0.08);
  }
}

.stat-content {
  flex: 1;
  min-width: 0;
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  .contract-card & {
    color: #2564CF;
  }
  
  .task-card & {
    color: #ff4d4f;
  }
  
  .after-sales-card & {
    color: #52c41a;
  }
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  padding: 16px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 14px;
  color: #8c8c8c;
}

@media (max-width: 1000px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .cards-grid:has(> .card-wrapper:first-child:nth-last-child(-n+3)) {
    /* 只有1-3个卡片时只显示1行 */
    grid-template-rows: 1fr;
    height: 100%; /* 高度减半 */
    .project-card {
    width: 100%;
    height: 100%; /* 高度减半 */
    }
  }
}

@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
  
  .cards-grid:has(> .card-wrapper:first-child:nth-last-child(-n+3)) {
    /* 只有1-3个卡片时只显示1行 */
    grid-template-rows: 1fr;
    height: 100%; /* 高度减半 */
    .project-card {
    width: 100%;
    height: 100%; /* 高度减半 */
    }
  }
}
</style>